import { cn } from '@/lib/utils'
import { Typo3Image, Typo3Section } from '@/types/typo3'
import { Container, Img, Section } from '@/ui/components'
import { memo } from 'react'

interface SectionSingleImageProps extends React.HTMLAttributes<HTMLDivElement> {
  images?: Typo3Image[]
  section?: Typo3Section
  layout?: 'default' | 'wrapped'
}

const SectionSingleImage = ({
  images,
  section,
  layout = 'default',
  ...props
}: SectionSingleImageProps) => {
  if (!images || images?.length !== 1) {
    return null
  }

  return (
    <Section data={section} className="s-section-single-image py-xl" {...props}>
      <Container
        anim="fade-in"
        size={layout === 'wrapped' ? 'sm-fixed' : undefined}
      >
        {images?.length && (
          <div
            className={cn(
              'gap-gutter',
              layout === 'default' && 'md:grid md:grid-cols-12'
            )}
          >
            <div
              className={cn(
                '',
                layout === 'default' && 'md:col-span-7 lg:col-span-8'
              )}
            >
              <Img data={images[0]} sizes={`68rem`} className="w-full" />
            </div>
            <div
              className={cn(
                '',
                layout === 'default' &&
                  'md:col-span-5 lg:col-span-4 xl:col-span-3 xl:col-start-10'
              )}
            >
              {images[0]?.properties?.title && (
                <div className="textstyle-md-regular p-md bg-neutral-200 text-neutral-400">
                  {images[0]?.properties?.title}
                </div>
              )}
            </div>
          </div>
        )}
      </Container>
    </Section>
  )
}

export default memo(SectionSingleImage)
